module.exports = __webpack_public_path__ + "static/top-b78b5b92d013006891ab02f15f5647d4.png";